<script lang="ts">
  import type { ClassValue } from "svelte/elements";

  interface Props {
    width?: number | string | undefined;
    height?: number | string | undefined;
    pill?: boolean;
    class?: ClassValue;
  }

  let {
    width = undefined,
    height = undefined,
    pill = false,
    class: className,
    ...rest
  }: Props = $props();

  function formatSize(value: number | string | undefined, defaultValue: string): string {
    if (value === undefined) return defaultValue;
    if (typeof value === "number") return `${value}px`;
    return value;
  }
</script>

<div
  aria-hidden="true"
  {...rest}
  class={["relative overflow-hidden bg-alpha-050", pill ? "rounded-full" : "rounded-md", className]}
  style:height={formatSize(height, "24px")}
  style:width={formatSize(width, "100%")}
>
  <div class="skeleton-shine"></div>
</div>

<style>
  @reference "#tailwind.css";
  .skeleton-shine {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, transparent 0%, var(--color-skeleton) 50%, transparent 100%);
    animation: shine 2s infinite;
  }

  @keyframes shine {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
</style>
